import { StyleSheet } from 'react-native';

export const s = StyleSheet.create({
    rail: { width: '100%', maxWidth: 1180, marginHorizontal: 'auto', paddingHorizontal: 28 },
    section: { paddingVertical: 72, borderTopWidth: 1, borderColor: '#dcded4' },
    green: { backgroundColor: '#e9eee5' },
    h2: { color: '#193b2b', fontSize: 32, lineHeight: 39, letterSpacing: -0.8, fontWeight: '600', marginBottom: 18 },
    body: { color: '#3f4c43', fontSize: 17, lineHeight: 27, marginBottom: 16 },
    link: { color: '#315d3f', fontSize: 16, lineHeight: 25, textDecorationLine: 'underline' },
});
